(function($) {
    $(document).ready(function(){
        
        $('.team-nav-link a').each(function(index,link) {
            $(this).find('.name').text( $(this).data('name') );
            $(this).on('click',()=>{
                $(this).closest('.reveal').foundation('close');
                const target = $(this).data('target');
                console.log($('#team-modal-' + target));
                $('#team-modal-' + target).foundation('open');
            })
        });

    });
})(jQuery);